import FilledButton from 'primitives/Buttons/FilledButton';
import Input from 'primitives/Forms/Input';
import IProvideRadio from 'components/IProvideRadio';
import isValidEmail from 'utils/validate/isValidEmail';
import Label from 'primitives/Forms/Label';
import logger, { CONTEXTS } from 'modules/Logger';
import ReactDOM from 'react-dom';
import reduxFactory from 'state/factory';
import StandaloneView from './StandaloneView';
import { Component } from 'react';
import { compose } from 'redux';
import { connect } from 'react-redux';
import { generateResetPwEmail } from 'state/Session/actions';
import { getLang } from 'state/i18n/selectors';
import { getSiteUrl } from 'state/Config/selectors';
import { localize } from 'redux-i18n';
import { create as recaptchaCreate } from 'client/js/services/Recaptcha';

const store = reduxFactory();

class ForgotPasswordPageView extends Component {
  state = {
    error: null,
    success: false,
  };

  componentDidMount() {
    recaptchaCreate();
  }

  onSubmit = e => {
    e.preventDefault();

    const { translate } = this.props;

    const form = e.target;
    const email = form.querySelector('[name="email"]').value;
    const captchaResponse = form.querySelector(
      '[name="g-recaptcha-response"]',
    ).value;

    if (form.querySelectorAll('.error').length) return false;

    this.setState({ error: '' });

    if (!email || !isValidEmail(email)) {
      this.setState({
        error: translate('Please enter a valid email'),
      });
      return false;
    }
    if (!captchaResponse) {
      this.setState({
        error: translate('Please complete the CAPTCHA'),
      });
      return false;
    }

    this.props
      .generateResetPwEmail(email)
      .then(() => this.setState({ success: true }))
      .catch(response => {
        const { errors } = response.data;
        const err = errors?.[0] ?? {
          code: 999,
          description: 'Unknown error',
        };
        logger.error([CONTEXTS.AUTH, CONTEXTS.FORM], {}, err);
        if (err.code === 101 || err.code === 106) {
          this.setState({ success: true });
        } else if (response.status > 404 && response.status < 500) {
          this.setState({
            error: 'Too many requests, please try again in 15 minutes',
          });
        } else {
          this.setState({ error: err.description });
        }
      });

    return undefined;
  };

  render() {
    let content;
    const { translate } = this.props;
    let title = translate('Forgot Password');
    const returnToLoginLink = new URL(getSiteUrl(store.getState()));
    returnToLoginLink.searchParams.append('showLogin', 'true');

    let subtitle = (
      <p css={{ color: '#717277', marginBottom: '2rem' }}>
        {translate(
          'Enter your email address below to log in by email or reset your password',
        )}
      </p>
    );

    if (this.state.success) {
      title = translate('Check Your Email');
      subtitle = '';

      content = (
        <div>
          <p css={{ color: '#333333', lineHeight: '2.16rem' }}>
            {translate(
              "If an account exists, you'll receive a password reset link shortly. Check your spam folder if it takes more than a minute or two.",
            )}
          </p>
          <br />
          <div css={{ display: 'flex', justifyContent: 'center' }}>
            <FilledButton
              customSVGStyles={{}}
              onClick={() => {
                window.location = returnToLoginLink.toString();
              }}
              styleType="cta"
            >
              {translate('Return to Log In')}
            </FilledButton>
          </div>
        </div>
      );
    } else {
      content = (
        <form
          css={{ marginTop: '1rem' }}
          method="POST"
          onSubmit={this.onSubmit}
        >
          <p css={{ display: this.state.error ? 'block' : 'none' }}>
            {this.state.error}
          </p>
          <Label css={{ marginBottom: '1rem' }}>{translate('email')}</Label>
          <Input
            labelStyles={{ fontSize: '1.3rem' }}
            name="email"
            type="email"
          />
          <div className="g-recaptcha" css={{ marginTop: '2rem' }} />
          <FilledButton
            aria-label={translate('Save')}
            isBlock
            marginTop="2rem"
            styleType="cta"
            tabIndex={4}
            type="submit"
          >
            {translate('Send')}
          </FilledButton>
        </form>
      );
    }

    return (
      <StandaloneView subtitle={subtitle} title={title}>
        {content}
      </StandaloneView>
    );
  }
}

const ForgotPasswordPage = compose(
  localize('translate'),
  connect(null, { generateResetPwEmail }),
)(ForgotPasswordPageView);

const lang = getLang(store.getState());

ReactDOM.render(
  <IProvideRadio lang={lang} store={store}>
    <ForgotPasswordPage />
  </IProvideRadio>,
  document.body,
);
